import styles from "./index.module.scss";
import classes from "classnames";
import Table from "rc-table";
import { AlignType } from "rc-table/es/interface";
import { useEffect, useState } from "react";
import { ChallengeRank } from "../../../../types/challenge";
import { getChallengeRank } from "../../../../api";
export interface RankListProps {
  title: string;
  className?: string;
  type: "day" | "week" | "all";
}

const Number1 = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.74062 0H2.4155L6.86832 8.71282H13.1899L8.74062 0Z"
        fill="#F72426"
      />
      <path
        d="M11.2668 0L6.81754 8.71282H13.1401L17.5924 0H11.2668Z"
        fill="#F72426"
      />
      <path
        d="M10.0037 4.41333C8.48202 4.41262 6.99432 4.86324 5.72879 5.70819C4.46325 6.55313 3.47675 7.75444 2.89408 9.16014C2.31141 10.5658 2.15874 12.1128 2.4554 13.6053C2.75205 15.0977 3.48469 16.4687 4.56065 17.5447C5.6366 18.6208 7.00752 19.3535 8.49998 19.6503C9.99244 19.947 11.5394 19.7944 12.9451 19.2119C14.3509 18.6293 15.5522 17.6429 16.3973 16.3774C17.2423 15.1119 17.693 13.6242 17.6924 12.1026C17.6924 7.85641 14.2499 4.41384 10.0037 4.41384V4.41333ZM10.0037 18.4708C6.48678 18.4708 3.6355 15.6195 3.6355 12.1015C3.6355 8.58461 6.48678 5.73333 10.0037 5.73333C13.5211 5.73333 16.3724 8.58461 16.3724 12.102C16.3724 15.6195 13.5211 18.4708 10.0037 18.4708Z"
        fill="#F9E310"
      />
      <path
        d="M10.0037 5.73334C6.4873 5.73334 3.63602 8.58462 3.63602 12.1026C3.63602 15.62 6.4873 18.4713 10.0042 18.4713C13.5217 18.4713 16.3729 15.62 16.3729 12.1021C16.3729 8.58513 13.5217 5.73385 10.0042 5.73385L10.0037 5.73334ZM10.0037 17.5077C8.93338 17.5098 7.88648 17.1943 6.99554 16.6012C6.1046 16.008 5.40967 15.1639 4.99874 14.1756C4.5878 13.1873 4.47934 12.0993 4.68706 11.0493C4.89479 9.99929 5.40938 9.03455 6.16568 8.27717C6.92198 7.51979 7.88599 7.00384 8.93567 6.79461C9.98536 6.58539 11.0735 6.69231 12.0624 7.10184C13.0513 7.51136 13.8964 8.20508 14.4909 9.09518C15.0853 9.98527 15.4023 11.0317 15.4017 12.1021C15.4017 15.0851 12.9868 17.5051 10.0037 17.5108V17.5072V17.5077Z"
        fill="#F7931E"
      />
      <path
        d="M10.0037 6.69691C8.93336 6.69478 7.88645 7.01027 6.99549 7.60345C6.10454 8.19663 5.40962 9.04082 4.9987 10.0292C4.58778 11.0175 4.47934 12.1055 4.68711 13.1555C4.89488 14.2055 5.40952 15.1703 6.16587 15.9276C6.92222 16.685 7.88628 17.2009 8.93599 17.4101C9.98571 17.6192 11.0739 17.5122 12.0628 17.1026C13.0516 16.693 13.8968 15.9992 14.4911 15.1091C15.0855 14.2189 15.4024 13.1724 15.4017 12.102C15.4017 9.11947 12.9863 6.7005 10.0037 6.69691ZM10.8637 14.7456H9.98577V10.4646C9.63546 10.7734 9.21761 10.9958 8.76577 11.1138V10.2359C9.03265 10.1643 9.28927 10.0588 9.52936 9.92204C9.77449 9.77537 10.0012 9.59896 10.2037 9.39742H10.8637V14.7456Z"
        fill="#FFA357"
      />
    </svg>
  );
};

const Number2 = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.43304 0H2.10791L6.56073 8.71282H12.8823L8.43304 0Z"
        fill="#FF8180"
      />
      <path
        d="M10.959 0L6.50977 8.71282H12.8323L17.2846 0H10.959Z"
        fill="#FF8180"
      />
      <path
        d="M9.6959 4.41309C8.17422 4.41238 6.68652 4.863 5.42099 5.70794C4.15545 6.55289 3.16895 7.7542 2.58628 9.1599C2.00361 10.5656 1.85094 12.1125 2.1476 13.605C2.44425 15.0975 3.17689 16.4685 4.25285 17.5445C5.3288 18.6205 6.69972 19.3533 8.19218 19.65C9.68464 19.9468 11.2316 19.7942 12.6373 19.2116C14.0431 18.629 15.2444 17.6426 16.0895 16.3771C16.9345 15.1117 17.3852 13.624 17.3846 12.1023C17.3846 7.85616 13.9421 4.4136 9.6959 4.4136V4.41309ZM9.6959 18.4705C6.17898 18.4705 3.3277 15.6192 3.3277 12.1013C3.3277 8.58437 6.17898 5.73309 9.6959 5.73309C13.2133 5.73309 16.0646 8.58437 16.0646 12.1018C16.0646 15.6192 13.2133 18.4705 9.6959 18.4705Z"
        fill="#F9E310"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.69238 18C13.0061 18 15.6924 15.3137 15.6924 12C15.6924 8.68629 13.0061 6 9.69238 6C6.37867 6 3.69238 8.68629 3.69238 12C3.69238 15.3137 6.37867 18 9.69238 18ZM11.0324 9.148C10.6804 8.828 10.2244 8.676 9.68038 8.676C9.07238 8.676 8.57638 8.876 8.20838 9.292C7.84838 9.676 7.66438 10.188 7.65638 10.828H8.52838C8.54438 10.364 8.64038 10.02 8.83238 9.78C9.01638 9.532 9.28838 9.412 9.64838 9.412C9.98438 9.412 10.2484 9.492 10.4244 9.652C10.6004 9.812 10.6884 10.052 10.6884 10.372C10.6884 10.708 10.5524 11.02 10.2964 11.308C10.1364 11.476 9.86438 11.692 9.48038 11.964C8.83238 12.412 8.40038 12.756 8.19238 13.004C7.80838 13.436 7.62438 13.932 7.62438 14.5H11.5604V13.732H8.70438C8.82438 13.42 9.19238 13.06 9.80838 12.652C10.3764 12.268 10.7684 11.964 10.9924 11.732C11.3604 11.324 11.5524 10.876 11.5524 10.38C11.5524 9.876 11.3764 9.468 11.0324 9.148Z"
        fill="#FFA357"
      />
      <path
        d="M9.69631 5.7334C6.1799 5.7334 3.32861 8.58468 3.32861 12.1026C3.32861 15.6201 6.17989 18.4713 9.69682 18.4713C13.2143 18.4713 16.0655 15.6201 16.0655 12.1021C16.0655 8.58519 13.2143 5.73391 9.69682 5.73391L9.69631 5.7334ZM9.69631 17.5078C8.62598 17.5099 7.57908 17.1944 6.68813 16.6013C5.79719 16.0081 5.10227 15.1639 4.69134 14.1756C4.2804 13.1873 4.17193 12.0993 4.37966 11.0493C4.58739 9.99935 5.10197 9.03461 5.85827 8.27723C6.61457 7.51986 7.57858 7.0039 8.62827 6.79467C9.67795 6.58545 10.7661 6.69237 11.755 7.1019C12.7439 7.51142 13.589 8.20514 14.1835 9.09524C14.7779 9.98534 15.0949 11.0318 15.0943 12.1021C15.0943 15.0852 12.6794 17.5052 9.69631 17.5108V17.5072V17.5078Z"
        fill="#F7931E"
      />
    </svg>
  );
};

const Number3 = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M8.43304 0H2.10791L6.56073 8.71282H12.8823L8.43304 0Z"
        fill="#40BF9C"
      />
      <path
        d="M10.959 0L6.50977 8.71282H12.8323L17.2846 0H10.959Z"
        fill="#40BF9C"
      />
      <path
        d="M9.6959 4.41309C8.17422 4.41238 6.68652 4.863 5.42099 5.70794C4.15545 6.55289 3.16895 7.7542 2.58628 9.1599C2.00361 10.5656 1.85094 12.1125 2.1476 13.605C2.44425 15.0975 3.17689 16.4685 4.25285 17.5445C5.3288 18.6205 6.69972 19.3533 8.19218 19.65C9.68464 19.9468 11.2316 19.7942 12.6373 19.2116C14.0431 18.629 15.2444 17.6426 16.0895 16.3771C16.9345 15.1117 17.3852 13.624 17.3846 12.1023C17.3846 7.85616 13.9421 4.4136 9.6959 4.4136V4.41309ZM9.6959 18.4705C6.17898 18.4705 3.3277 15.6192 3.3277 12.1013C3.3277 8.58437 6.17898 5.73309 9.6959 5.73309C13.2133 5.73309 16.0646 8.58437 16.0646 12.1018C16.0646 15.6192 13.2133 18.4705 9.6959 18.4705Z"
        fill="#F9E310"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.5C13.3137 18.5 16 15.8137 16 12.5C16 9.18629 13.3137 6.5 10 6.5C6.68629 6.5 4 9.18629 4 12.5C4 15.8137 6.68629 18.5 10 18.5ZM11.34 9.592C10.988 9.312 10.532 9.176 9.956 9.176C9.396 9.176 8.94 9.328 8.588 9.648C8.212 9.968 8.004 10.408 7.956 10.976H8.812C8.844 10.624 8.964 10.36 9.156 10.184C9.348 10.008 9.62 9.92 9.964 9.92C10.3 9.92 10.564 9.992 10.74 10.152C10.9 10.304 10.988 10.52 10.988 10.808C10.988 11.096 10.892 11.32 10.716 11.472C10.54 11.624 10.276 11.704 9.924 11.704H9.516V12.36H9.932C10.308 12.36 10.596 12.44 10.788 12.6C10.996 12.76 11.1 13.008 11.1 13.344C11.1 13.632 10.996 13.864 10.804 14.056C10.58 14.264 10.284 14.376 9.916 14.376C9.58 14.376 9.308 14.28 9.1 14.088C8.86 13.88 8.74 13.584 8.724 13.2H7.844C7.892 13.84 8.116 14.328 8.516 14.664C8.868 14.96 9.34 15.112 9.924 15.112C10.532 15.112 11.036 14.936 11.42 14.6C11.78 14.264 11.964 13.832 11.964 13.304C11.964 12.968 11.868 12.688 11.676 12.472C11.5 12.264 11.244 12.104 10.908 12C11.532 11.792 11.852 11.368 11.852 10.744C11.852 10.256 11.676 9.872 11.34 9.592Z"
        fill="#FFA357"
      />
      <path
        d="M9.69631 5.7334C6.1799 5.7334 3.32861 8.58468 3.32861 12.1026C3.32861 15.6201 6.17989 18.4713 9.69682 18.4713C13.2143 18.4713 16.0655 15.6201 16.0655 12.1021C16.0655 8.58519 13.2143 5.73391 9.69682 5.73391L9.69631 5.7334ZM9.69631 17.5078C8.62598 17.5099 7.57908 17.1944 6.68813 16.6013C5.79719 16.0081 5.10227 15.1639 4.69134 14.1756C4.2804 13.1873 4.17193 12.0993 4.37966 11.0493C4.58739 9.99935 5.10197 9.03461 5.85827 8.27723C6.61457 7.51986 7.57858 7.0039 8.62827 6.79467C9.67795 6.58545 10.7661 6.69237 11.755 7.1019C12.7439 7.51142 13.589 8.20514 14.1835 9.09524C14.7779 9.98534 15.0949 11.0318 15.0943 12.1021C15.0943 15.0852 12.6794 17.5052 9.69631 17.5108V17.5072V17.5078Z"
        fill="#F7931E"
      />
    </svg>
  );
};

const COLUMNS = [
  {
    title: "排名",
    width: 50,
    dataIndex: "rank",
    render: (rank: number) => {
      if (rank === 1) {
        return <Number1 />;
      }
      if (rank === 2) {
        return <Number2 />;
      }
      if (rank === 3) {
        return <Number3 />;
      }
      return <span className={styles.rankNumber}>{rank}</span>;
    },
  },
  {
    title: "用户",
    width: 150,
    align: "left" as AlignType,
    dataIndex: "user",
    render: (user: ChallengeRank["ranks"][0]["user"]) => {
      return (
        <div className={styles.user}>
          <img
            className={styles.avatar}
            src={
              user.avatar ||
              `https://api.dicebear.com/6.x/bottts/png?seed=${user.nickname}`
            }
            alt=""
          />
          <div className={styles.nickname}>{user.nickname}</div>
        </div>
      );
    },
  },
  {
    title: "解题数",
    width: 64,
    dataIndex: "score",
    render: (score: number) => {
      return <span className={styles.score}>{score}</span>;
    },
  },
];

const RankList = ({ title, className, type }: RankListProps) => {
  const [ranks, setRanks] = useState<ChallengeRank["ranks"]>([]);
  useEffect(() => {
    getChallengeRank(type).then((data) => {
      setRanks(data.ranks);
    });
  }, [type]);
  return (
    <div className={classes(styles.rankList, className)}>
      <div className={styles.header}>{title}</div>
      <div className={styles.body}>
        <Table rowKey="rank" columns={COLUMNS} data={ranks} />
      </div>
    </div>
  );
};

export default RankList;
